export var CACHE_CONTROL = "public, max-age=600, s-maxage=600, stale-while-revalidate=200, stale-if-error=300";